import { Navigate } from "react-router-dom";
import { getToken, isTokenExpired, removeToken } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const token = getToken();

  if (!token || isTokenExpired(token)) {
    removeToken();
    return <Navigate to="/parentlogin" replace />;
  }

  return children;
};

export default ProtectedRoute;